/*
  FaD v5.64 — staggered review wall
  --------------------------------------------------------------
  Builds a true masonry wall on desktop: cards are placed into the
  shortest column as we go, which balances far better than a rigid
  grid, and the middle column carries a deliberate vertical offset
  so the wall reads as staggered rather than three parallel stacks.

  Progressive enhancement. If this never runs, the CSS multi-column
  fallback in theme.css still gives a packed masonry, and below
  768px the original single-column grid is untouched so the mobile
  "read all reviews" collapse keeps working exactly as before.
*/
(function () {
  'use strict';

  var MQ = '(min-width: 768px)';
  var SEL = '.reviews-grid';

  function colCount() {
    return window.innerWidth >= 1024 ? 3 : 2;
  }

  function build(grid) {
    var cards = grid.__fadCards;
    var n = colCount();

    // tear down any previous wall
    var old = grid.querySelector('.rwall');
    if (old) old.remove();

    var wall = document.createElement('div');
    wall.className = 'rwall';
    wall.setAttribute('data-cols', n);

    var cols = [];
    for (var i = 0; i < n; i++) {
      var col = document.createElement('div');
      col.className = 'rwall__col';
      col.setAttribute('data-col', i);
      wall.appendChild(col);
      cols.push({ el: col, h: 0 });
    }

    // place each card into whichever column is currently shortest
    cards.forEach(function (card) {
      var target = cols[0];
      for (var i = 1; i < cols.length; i++) {
        if (cols[i].h < target.h) target = cols[i];
      }
      target.el.appendChild(card);
      // measured after paint; use a cheap proxy until then
      target.h += card.offsetHeight || 400;
    });

    grid.appendChild(wall);
    grid.classList.add('is-wall');

    // Images load after first paint, so the placement above uses
    // provisional heights. Rebalance once every image in the wall has
    // settled, which is when the real heights are finally known.
    var imgs = Array.prototype.slice.call(wall.querySelectorAll('img'));
    var pending = imgs.filter(function (im) { return !im.complete; }).length;

    function rebalance() {
      var c2 = Array.prototype.map.call(wall.children, function (el) {
        return { el: el, h: 0 };
      });
      cards.forEach(function (card) {
        var t = c2[0];
        for (var i = 1; i < c2.length; i++) if (c2[i].h < t.h) t = c2[i];
        t.el.appendChild(card);
        t.h += card.getBoundingClientRect().height;
      });
    }

    if (pending === 0) {
      requestAnimationFrame(rebalance);
    } else {
      var done = 0;
      imgs.forEach(function (im) {
        if (im.complete) return;
        var tick = function () {
          done++;
          im.removeEventListener('load', tick);
          im.removeEventListener('error', tick);
          if (done >= pending) requestAnimationFrame(rebalance);
        };
        im.addEventListener('load', tick);
        im.addEventListener('error', tick);
      });
      // never leave it unbalanced if an image stalls
      setTimeout(function () { if (done < pending) requestAnimationFrame(rebalance); }, 3000);
    }
  }

  function teardown(grid) {
    var wall = grid.querySelector('.rwall');
    if (!wall) return;
    grid.__fadCards.forEach(function (c) { grid.appendChild(c); });
    wall.remove();
    grid.classList.remove('is-wall');
    grid.__fadRebalanced = false;
  }

  function init() {
    var grid = document.querySelector(SEL);
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.rcard'));
    if (cards.length < 3) return;
    grid.__fadCards = cards;

    var mql = window.matchMedia(MQ);
    var lastCols = null;

    function apply() {
      if (mql.matches) {
        var n = colCount();
        if (n !== lastCols || !grid.classList.contains('is-wall')) {
          lastCols = n;
          build(grid);
        }
      } else {
        lastCols = null;
        teardown(grid);
      }
    }

    apply();

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(apply, 150);
    }, { passive: true });

    if (mql.addEventListener) mql.addEventListener('change', apply);
    else if (mql.addListener) mql.addListener(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
